/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	PracticeStudentsDTO,
	PracticeStudentsDTOFromJSON,
	PracticeStudentsDTOFromJSONTyped,
	PracticeStudentsDTOToJSON,
} from "./PracticeStudentsDTO";

/**
 *
 * @export
 * @interface PracticeStudentsDTOPagedResponse
 */
export interface PracticeStudentsDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof PracticeStudentsDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PracticeStudentsDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PracticeStudentsDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<PracticeStudentsDTO>}
	 * @memberof PracticeStudentsDTOPagedResponse
	 */
	data?: Array<PracticeStudentsDTO> | null;
}

export function PracticeStudentsDTOPagedResponseFromJSON(
	json: any
): PracticeStudentsDTOPagedResponse {
	return PracticeStudentsDTOPagedResponseFromJSONTyped(json, false);
}

export function PracticeStudentsDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PracticeStudentsDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(PracticeStudentsDTOFromJSON),
	};
}

export function PracticeStudentsDTOPagedResponseToJSON(
	value?: PracticeStudentsDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(PracticeStudentsDTOToJSON),
	};
}
